import moment from 'moment'
import { applyMaskCpfCnpj, formatPhone } from '../../../../utils/formater'
function translateStatus(status: string) {
    switch (status) {
        case 'active':
            return 'Ativo'
        case 'inactive':
            return 'Inativo'
        case 'blocked':
            return 'Bloqueado'
        case 'pending':
            return 'Pendente'

        default:
            return 'Não informado'
    }
}


export function customerMapper(data: any): {
    id: string
    name: string
    email: string
    doc: string
    status: string
    phone: string
    created: string
    group: string
    selected: boolean
} {
    try {
        const principalPhone = data.customerPhones.find(
            (phone: { typePhone: string; numberPhone: string }) =>
                phone.typePhone === 'principal' && phone.numberPhone !== ''
        ) || { numberPhone: '' }

        return {
            id: data.id,
            name: data.name,
            email: data.email ? data.email : '-/-',
            doc: data.doc ? applyMaskCpfCnpj(data.doc) : '-/-',
            status: translateStatus(data.status),
            phone:
                principalPhone && principalPhone.numberPhone
                    ? formatPhone(principalPhone.numberPhone)
                    : '-/-',
            created: moment(data.created).utcOffset(-3).toISOString(), // Adjusted to Brazil time
            group: data?.customerGroupMemberships
                ? data.customerGroupMemberships.group?.name
                : 'Sem Grupo',
            selected: false,
        }
    } catch (error) {
        console.error('Erro ao mapear o cliente:', error)
        return {
            id: data.id || '',
            name: data.name || '-/-',
            email: data.email || '-/-',
            doc: data.doc ? applyMaskCpfCnpj(data.doc) : '-/-',
            status: translateStatus(data.status || ''),
            phone: '-/-',
            created: data.created ? moment(data.created).utcOffset(-3).format('DD/MM/YYYY HH:mm:ss') : '-/-',
            group: 'Sem Grupo',
            selected: false,
        }
    }
}